import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getProjectLogsById } from 'apis/projectProposals.api';

const useGetProjectLogs = (id, conds) => {
  const { data, ...rest } = useQuery(['getProjectLogsById', id], () => getProjectLogsById(id), {
    ...conds,
  });

  const projectLogs = useMemo(() => data?.data ?? [], [data]);
  return {
    data: projectLogs,
    ...rest,
  };
};

export default useGetProjectLogs;
